const toPoint = point => ({
    lat: Number(typeof point.lat === 'function' ? point.lat() : point.lat),
    lng: Number(typeof point.lng === 'function' ? point.lng() : point.lng),
});

export function getRoutePath(route) {
    const detailedPath = (route?.legs || []).flatMap(leg =>
        (leg.steps || []).flatMap(step => step.path || []));
    return (detailedPath.length > 1 ? detailedPath : route?.overview_path || []).map(toPoint);
}

// Project onto road segments rather than jumping between overview vertices.
// Keep progress monotonic so GPS jitter cannot redraw already travelled road.
export function getRemainingRoute(path, location, previousProgress = 0) {
    let progress = previousProgress;
    if (location && path.length > 1) {
        const point = toPoint(location);
        const lngScale = Math.cos(point.lat * Math.PI / 180);
        let closestDistance = Infinity;
        let closestProgress = progress;
        for (let i = Math.floor(progress); i < path.length - 1; i++) {
            const start = path[i];
            const end = path[i + 1];
            const dx = (end.lng - start.lng) * lngScale;
            const dy = end.lat - start.lat;
            const lengthSquared = dx * dx + dy * dy;
            if (!lengthSquared) continue;
            const fraction = Math.max(0, Math.min(1,
                (((point.lng - start.lng) * lngScale * dx) + (point.lat - start.lat) * dy) / lengthSquared));
            const distance = Math.hypot(
                (point.lng - start.lng) * lngScale - fraction * dx,
                point.lat - start.lat - fraction * dy,
            ) * 111320;
            // Prefer the earliest segment at crossings.
            if (distance < closestDistance - 0.1) {
                closestDistance = distance;
                closestProgress = i + fraction;
            }
        }
        // An unrelated/off-road GPS fix must not consume the route.
        if (closestDistance <= 80) progress = Math.max(progress, closestProgress);
    }

    if (path.length < 2 || progress >= path.length - 1) return { progress, path: [] };
    const index = Math.floor(progress);
    const fraction = progress - index;
    const start = path[index];
    const end = path[index + 1];
    return {
        progress,
        path: [{
            lat: start.lat + (end.lat - start.lat) * fraction,
            lng: start.lng + (end.lng - start.lng) * fraction,
        }, ...path.slice(index + 1)],
    };
}
